import { FakDokumentView } from "../fak-dokument-view";

export class FakDokumentIzvozView extends FakDokumentView
{
    constructor(){
        super();
    }
    
    Valuta: string = null;
    Kurs: number = null;
    UkupnoDevizno: number = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.Valuta = input.Valuta;
        this.Kurs = input.Kurs;
        this.UkupnoDevizno = input.UkupnoDevizno;
        return this;
    }

    Serialize(input: FakDokumentIzvozView){
        return input;
    }
}